
import { Vue, Options, prop } from "vue-class-component";
import debounce from "lodash/debounce";
import { VendorController } from "@/app/ui/controllers/VendorController";
import { VendorData } from "@/domain/entities/Vendor";

class Props {
  modelValue = prop<any>({});
  placeholder = prop<string>({
    default: "Pilih vendor"
  });
  status = prop<string>({
    default: ""
  });
  disabled = prop<boolean>({
    default: false
  });
  keyName = prop<string>({
    default: "name"
  });
  keyValue = prop<string>({
    default: "code"
  });
}

@Options({
  emits: ["update:modelValue", "change"]
})
export default class SelectVendor extends Vue.with(Props) {
  isLoadingVendor = true;
  listVendor: VendorData[] = [];
  fetchVendor = debounce(async (search: string) => {
    this.isLoadingVendor = true;
    const responseVendor = await VendorController.getVendorList({
      search: search,
      status: this.status,
      page: 1,
      limit: 10
    });
    this.listVendor = responseVendor.data;
    this.isLoadingVendor = false;
  }, 250);
  get optionVendor(): VendorData[] {
    return this.listVendor;
  }
  onBlur() {
    this.isLoadingVendor = true;
  }
}
